export const DEFAULT_PAGE_SIZE = 10;
export const CONTROL_RATIOS_API_PREFIX = 'control-ratios';
